import { Card as BaseCard } from '@chilecompra/react-kit/components'
import { Container as ContainerBase, Grid as BaseGrid, styled } from '@mui/material'
import React from 'react'

export const Card = styled(({ children, textAlign, ...props }) => <BaseCard {...props}>{children}</BaseCard>)`
  align-items: ${props => props.alignItems};
  display: flex;
  height: ${props => props.height};
  margin: ${props => props.margin};
  text-align: ${props => props.textAlign};
  width: ${props => props.width};
`

export const CardItem = styled(({ ...props }) => <div {...props} />)`
  align-items: center;
  display: flex;
  flex-direction: ${props => props.direction || 'flex'};
  justify-content: center;
  padding: ${props => props.padding};
`

export const Column = styled(({ ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    flex-basis: ${props => props.flexBasis};
    flex-grow: ${props => props.flexGrow};
    margin: ${props => props.margin};
    width: ${props => props.width};
  }
`

export const ColumnChart = styled(({ ...props }) => <BaseGrid item {...props} />)`
  align-content: ${props => props.alignContent};
  display: flex;
  flex-direction: ${props => props.flexDirection};
  flex-wrap: ${props => props.flexWrap};
  justify-content: ${props => props.justifyContent};
`

export const GridContainer = styled(({ height, margin, maxWidth, padding, ...props }) => (
  <BaseGrid container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: auto;
  margin: ${props => props.margin};
  width: 82px;
`

export const Root = styled(ContainerBase)`
  padding: 0;

  &.MuiContainer-root {
    width: 100%;
  }
`

export const Row = styled(({ ...props }) => <BaseGrid container {...props} />)`
  flex-wrap: ${props => props.flexWrap};
  gap: ${props => props.gap};
  justify-content: ${props => props.justifyContent};

  @media (max-width: 744px) {
    flex-wrap: wrap;
    gap: 0;
  }
`

export const RowChart = styled(({ ...props }) => <BaseGrid container {...props} />)`
  border: 1px solid ${props => props.theme.palette.brand.gray2};
  border-radius: 4px;
  justify-content: ${props => props.justifyContent};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: ${props => props.width};
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 19px 20px 22px 20px;
  overflow: visible;
  ${props => props.theme.breakpoints.up('sm')} {
    margin: 19px 30px 22px 45px;
  }
  ${props => props.theme.breakpoints.up('lg')} {
    margin: 19px 30px 22px 55px;
    max-width: 310px;
  }
`

export const WarningImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: 48px;
  margin: ${props => props.margin};
  width: 48px;
`
